import { CloudFunction } from '../../../pure-js/enums/CloudFunction.js'
import { ServerErrorDetails } from '../../../pure-js/types/ServerTypes.js'

export type CloudFunctionErrorType = { code: string; message: string; details?: ServerErrorDetails }

export default class CloudFunctionError extends Error {
  cloudFunctionError: CloudFunctionErrorType
  fnName: CloudFunction

  constructor(cloudFunctionError: CloudFunctionErrorType, fnName: CloudFunction) {
    super(cloudFunctionError.message)
    this.cloudFunctionError = cloudFunctionError
    this.fnName = fnName
  }
}
